import React, { Component, Suspense } from 'react';
import { BrowserRouter, Route, NavLink, Switch } from 'react-router-dom';
import { Box, Spinner, Flyout, Layer, Text, Link, Button, Column, Sticky, Modal } from 'gestalt';
import { Offline } from "react-detect-offline";
import './App.css'

import viewset from '../src/assets/viewset.png';
import FacebookAuth from 'react-facebook-auth';

import Header from './components/Header/Header';
import { SettingAppearance, SettingProfile, About, NavMore } from './containers/Settings/Settings';
import axios from 'axios';

const Home = React.lazy(() => import('./containers/Home/Home'))
const Explore = React.lazy(() => import('./containers/Explore/Explore'))
const Pages = React.lazy(() => import('./containers/Pages/Pages'))
const Collections = React.lazy(() => import('./containers/Collections/Collections'))
const Profile = React.lazy(() => import('./containers/Profile/Profile'))
const Settings = React.lazy(() => import('./containers/Settings/Settings'))
const Load = React.lazy(() => import('./containers/Load/Load'))
const Search = React.lazy(() => import('./containers/Search/Search'))

class App extends Component {

  constructor(props) {
    super(props);
    const cookies = props;
    this.state = { login_state: false, open: false, tokenValue: this.getCookieValue('token'), token: this.getCookie('token'), dark: this.darkValue(localStorage.getItem('dark'))};
    this.handleClick = this._handleClick.bind(this);
    this.handleDismiss = this._handleDismiss.bind(this);
    this.anchorRef = React.createRef();
  }
  _handleClick() {
    this.setState(() => ({ open: !this.state.open }));
  }
  _handleDismiss() {
    this.setState(() => ({ open: false }));
  }

  darkValue(val){
    return val === 'true'
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';')
    for(var i=0; i < ca.length; i++){
      var c = ca[i];
      while (c.charAt(0) == ' '){
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0){
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  getCookieValue(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';')
    for(var i=0; i < ca.length; i++){
      var c = ca[i];
      while (c.charAt(0) === ' '){
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0){
        return true;
      }
    }
    return false;
  }

  setCookie(cname, cvalue, exdays){
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  
  render() { 

    const imgStyle = {
      width: '100%',
      height: 'auto'
    };

    const initialState = {
      token: this.state.loginToken
    }

    const MyFacebookButton = ({ onClick }) => (
      <Button color='blue' text='Continue with Facebook' inline onClick={onClick}>
        Continue with facebook
      </Button>
    );

    const authenticate = (response) => {
      this.setCookie("dp", response.picture.data.url, 30)
      var postData = {
          access_token: response.accessToken,
      };
      let axiosConfig = {
          headers: {
              'Content-Type': 'application/json;charset=UTF-8',
          }
      }
      this.setState({ login_state: true })

      axios.post('https://baeges.herokuapp.com/api/rest-auth/facebook/', postData, axiosConfig)
          .then(res => {
              this.setState(()=>({login_state: false}))
              this.setState(() => ({ token: "Token "+res.data.key }))
              this.setState(() => ({ tokenValue: true }))
              this.setCookie("token", "Token "+res.data.key, 30)
              this.setCookie("new", true, 30)

              let axiosConfig = {
                headers: {
                    'Authorization': this.state.token,
                    'Content-Type': 'application/json',
                }
            }

              axios.get('https://baeges.herokuapp.com/api/profile/', axiosConfig)
              .catch(err => {
                console.log(err)
              })
          })
          .catch(err => {
              console.log(err)
          })
    };

    
console.log(this.state.dark)
    return (
      <Box column={12} color={this.state.dark ? 'darkGray' : 'white'} minHeight={window.screen.height}>
        <Offline> <Box color='transparentDarkGray' padding={2}><Text color='orange'>It seems you are either offline or your internet connection is unstable. Sorry about that 😒.</Text></Box> </Offline>
          <BrowserRouter>
          <React.Fragment>
            {window.location.pathname.includes('load') ? null : <Header color={this.state.dark ? 'darkGray' : 'white'} /> }
            <Box column={12} wrap={true} display='flex'>

            {window.location.pathname.includes('load') ? null : 
              <Box mdDisplay='block' lgDisplay='block' display='inlineBlock' column={12} mdColumn={2} lgColumn={2} smColumn={12}>
                <Box mdColumn={12} lgColumn={12} column={3} display='inlineBlock' mdDisplay='block' lgDisplay='block'><center><NavLink exact className='navLink' activeClassName='activeNavLink' to='/'>Home</NavLink></center></Box>
                <Box mdColumn={12} lgColumn={12} column={3} display='inlineBlock' mdDisplay='block' lgDisplay='block'><center><NavLink className='navLink' activeClassName='activeNavLink' to='/explore'>Explore</NavLink></center></Box>
                <Box mdColumn={12} lgColumn={12} column={3} display='inlineBlock' mdDisplay='block' lgDisplay='block'><center><NavLink className='navLink' activeClassName='activeNavLink' to='/pages'>Pages</NavLink></center></Box>
                {/* <Box mdColumn={12} lgColumn={12} column={3} display='inlineBlock' mdDisplay='block' lgDisplay='block'><center><NavLink className='navLink' activeClassName='activeNavLink' to='/notifications'>Notifications</NavLink></center></Box> */}
                <Box ref={this.anchorRef} mdColumn={12} lgColumn={12} column={3} display='inlineBlock' mdDisplay='none' lgDisplay='none'><center><NavLink className='navLink' activeClassName='activeNavLink' to='/more'>More</NavLink></center></Box>
                <Box mdColumn={12} lgColumn={12} display='none' mdDisplay='block' lgDisplay='block'><center><NavLink className='navLink' activeClassName='activeNavLink' to='/collections'>Starred Posts</NavLink></center></Box>
                <Box mdColumn={12} lgColumn={12} display='none' mdDisplay='block' lgDisplay='block'><center><NavLink className='navLink' activeClassName='activeNavLink' to='/settings'>Settings</NavLink></center></Box>
                {this.state.open &&
                  <Flyout
                    anchor={this.anchorRef.current}
                    idealDirection='left'
                    onDismiss={this.handleDismiss}
                    size='sm'
                  >
                    <Box padding={3} display='flex' column={12}>
                      <Box display='inlineBlock' column={6}><center><NavLink className='navLink' activeClassName='activeNavLink' to='/collections'>Starred</NavLink></center></Box>
                      <Box display='inlineBlock' column={6}><center><NavLink className='navLink' activeClassName='activeNavLink' to='/settings'>Settings</NavLink></center></Box>
                    </Box>
                  </Flyout>}
              </Box> }
              {/* Main Area */}
              <Box mdDisplay='block' lgDisplay='block' display='inlineBlock' column={12} mdColumn={10} lgColumn={10} smColumn={12} mdPadding={3} paddingY={5}>
                {/* all my routes are here */}
                {this.state.tokenValue &&
                <Switch>
                  <Route path='/' exact render={() => (
                    <Suspense fallback={<Spinner show={true} accessibilityLabel="spinner" />}>
                      <Home />
                    </Suspense>)} />
                  <Route path='/explore' render={() => (
                    <Suspense fallback={<Spinner show={true} accessibilityLabel="spinner" />}>
                      <Explore />
                    </Suspense>)} />
                  <Route path='/pages' render={() => (
                    <Suspense fallback={<Spinner show={true} accessibilityLabel="spinner" />}>
                      <Pages />
                    </Suspense>)} />
                  <Route path='/more' render={() => (
                    <Suspense fallback={<Spinner show={true} accessibilityLabel="spinner" />}>
                      <NavMore />
                    </Suspense>)} />
                  <Route path='/collections' render={() => (
                    <Suspense fallback={<Spinner show={true} accessibilityLabel="spinner" />}>
                      <Collections />
                    </Suspense>)} />
                  <Route path='/profile' render={() => (
                    <Suspense fallback={<Spinner show={true} accessibilityLabel="spinner" />}>
                      <Profile />
                    </Suspense>)} />
                  <Route path='/settings' exact render={() => (
                    <Suspense fallback={<Spinner show={true} accessibilityLabel="spinner" />}>
                      <Settings />
                    </Suspense>)} />
                  <Route path='/settings/appearance' exact render={() => (
                    <Suspense fallback={<Spinner show={true} accessibilityLabel="spinner" />}>
                      <SettingAppearance />
                    </Suspense>)} />
                  <Route path='/settings/profile' exact render={() => (
                    <Suspense fallback={<Spinner show={true} accessibilityLabel="spinner" />}>
                      <SettingProfile />
                    </Suspense>)} />
                  <Route path='/load/:postID' render={props => (
                    <Suspense fallback={<Spinner show={true} accessibilityLabel="spinner" />}>
                      <Load {...props} />
                    </Suspense>)} />
                  <Route path='/search/load/:postID' render={props => (
                    <Suspense fallback={<Spinner show={true} accessibilityLabel="spinner" />}>
                      <Load {...props} />
                    </Suspense>)} />
                  <Route path='/search/:searchTerm' render={props => (
                    <Suspense fallback={<Spinner show={true} accessibilityLabel="spinner" />}>
                      <Search {...props} />
                    </Suspense>)} />
                  <Route path='explore/search/:searchTerm' render={props => (
                    <Suspense fallback={<Spinner show={true} accessibilityLabel="spinner" />}>
                      <Search {...props} />
                    </Suspense>)} />
                  <Route path='/about' render={props => (
                    <Suspense fallback={<Spinner show={true} accessibilityLabel="spinner" />}>
                      <About />
                    </Suspense>)} />
                  <Route path='/:profileNAME' render={props => (
                    <Suspense fallback={<Spinner show={true} accessibilityLabel="spinner" />}>
                      <Profile show={true} {...props} />
                    </Suspense>)} />
                </Switch>}
              </Box>
            </Box>
          </React.Fragment>
          { !this.state.tokenValue &&
          <Layer>
              <Box color='white' display='flex' direction='column' smDirection='row' column={12} position="fixed" top left right bottom display="flex" alignItems="center" justifyContent="center"> 
                <Box lgColumn={6} smColumn={6} mdColumn={6} display='inlineBlock' >
                  <img style={imgStyle} src={viewset}></img>
                </Box>
                <Box padding={6} lgColumn={6} mdColumn={6} smColumn={6} display='inlineBlock' >
                  <b><h1>Never miss another favourite blog post.</h1></b>

                  <Text color='darkWash'><h3>Follow the websites you love and we will make sure you see them in one place and on time.</h3></Text>
                  
                  <FacebookAuth
                    appId="3745468368813402"
                    callback={authenticate}
                    component={MyFacebookButton}
                  />
                  <h6></h6>
                    <Text color='eggplant'>
                    <Box display='flex' column={12}></Box>
                      <Box display='inlineBlock' column={3}><a className='activeNavLink' href='https://www.privacypolicygenerator.info/live.php?token=0CBigYYa5ZexTrarQwcdiPCszSAEcIy1'>Privacy</a></Box>
                      <Box display='inlineBlock' column={3}><a className='activeNavLink' href='/about'>About</a></Box>
                      <Box display='inlineBlock' column={3}><a className='activeNavLink' href='tel:-08035336810'>Contact</a> </Box>
                    </Text>
                </Box>
              </Box>
            </Layer>
        }
        {
          this.state.login_state && 
          <Layer>
            <Modal
              heading='1 sec. logging in...'
              size='sm'
              footer={<></>}
            >
              <Spinner show={true} />
            </Modal>
          </Layer>
        }
        </BrowserRouter >
        </Box>
        );
        }
  }

export default App;
